<template>
  <SelectBox
    @open="getItems"
    @search="getItems"
    @option:selected="$emit('option:selected', $event)"
    :options="items"
    :validActivated="validActivated"
    :label="label"
    :noLabel="noLabel"
    :value="value"
    :disabled="disabled"
    :clearable="clearable"
    @input="$emit('input', $event)"
  >
    <template #selected-option="{ item }">
      {{ item.key }}
    </template>
    <template #option="{ item }">
      {{ item.key }}
    </template>
    <template
      #not-auth
      v-if="$status.getInsulationMaterials === 'NOT_AUTHORIZED'"
    >
      <not-auth></not-auth>
    </template>
  </SelectBox>
</template>

<script>
import Requests from "@/services/Requests";
import SelectBox from "@/components/Base/Inputs/SelectBox.vue";
export default {
  components: {
    SelectBox,
  },
  data() {
    return {
      items: [],
    };
  },
  props: {
    value: {
      default: null,
    },
    clearable: {
      default: false,
      type: Boolean,
    },
    noLabel: {
      default: false,
      type: Boolean,
    },
    label: {
      type: String,
      required: true,
    },
    validActivated: {
      default: false,
      type: Boolean,
    },
    query: {
      default: () => ({}),
      type: Object,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
  },
  methods: {
    /**
     * Makes a request to get all items that match the given search query.
     *
     * @param {string} search - search query to send to the API
     * @param {function} loading - function to call when the request is sending or done. Pass true to indicate sending, false to indicate done.
     */
    async getItems(search, loading) {
      loading(true);
      const response = await Requests.HeatGain.GetInsulationMaterials({
        query: { search: search, ...this.query },
      });
      this.$status.getInsulationMaterials = response.message;
      if (response.message === "OK") {
        this.items = response.data;
      } else {
        this.items = [];
      }
      loading(false);
      return this.items;
    },
    async setValue() {
      if (typeof this.value !== "object") {
        await this.getItems("", () => false);
        this.$emit(
          "input",
          this.items.find((item) => item.value === this.value)
        );
        console.log(this.items);
      }
    },
  },
  async mounted() {
    await this.setValue();
  },
};
</script>

<style></style>
